export const PERMISSIONS = [
  'OPS_DASHBOARD_READ', 'OPS_RISK_MAP_READ', 'OPS_CANDIDATE_READ', 'OPS_CANDIDATE_MANAGE',
  'OPS_ANALYSIS_READ', 'OPS_THRESHOLD_MANAGE', 'OPS_REPORT_EXPORT', 'OPS_SCENARIO_READ',
  'DATA_STATUS_READ', 'DATA_EXPORT_REQUEST', 'DATA_EXPORT_DOWNLOAD', 'DATA_ISSUE_ACKNOWLEDGE',
  'MODEL_METRICS_READ', 'MODEL_DIAGNOSTICS_READ', 'MODEL_ARTIFACT_REGISTER', 'MODEL_VALIDATE',
  'MODEL_APPROVE', 'MODEL_ACTIVATE', 'MODEL_ROLLBACK', 'MODEL_RELEASE_READ',
  'QNA_READ', 'QNA_ANSWER', 'QNA_STATE_CHANGE', 'QNA_HIDE', 'AUDIT_READ', 'ACCESS_READ',
  'ACCESS_ASSIGN', 'ACCESS_REVOKE', 'SYSTEM_STATUS_READ', 'AI_OPS_READ',
];

const OPS_VIEWER = ['OPS_DASHBOARD_READ', 'OPS_RISK_MAP_READ', 'OPS_CANDIDATE_READ', 'OPS_ANALYSIS_READ', 'DATA_STATUS_READ'];
const ROLE_BUNDLES = {
  OPS_VIEWER,
  OPS_OPERATOR: [...OPS_VIEWER, 'OPS_CANDIDATE_MANAGE', 'OPS_REPORT_EXPORT'],
  OPS_MANAGER: [...OPS_VIEWER, 'OPS_CANDIDATE_MANAGE', 'OPS_REPORT_EXPORT', 'OPS_THRESHOLD_MANAGE', 'OPS_SCENARIO_READ'],
  DATA_ANALYST: ['DATA_STATUS_READ', 'DATA_EXPORT_REQUEST', 'DATA_EXPORT_DOWNLOAD', 'DATA_ISSUE_ACKNOWLEDGE', 'OPS_ANALYSIS_READ', 'MODEL_METRICS_READ', 'MODEL_DIAGNOSTICS_READ'],
  MODEL_ENGINEER: ['MODEL_METRICS_READ', 'MODEL_DIAGNOSTICS_READ', 'MODEL_ARTIFACT_REGISTER', 'MODEL_VALIDATE', 'MODEL_RELEASE_READ'],
  MODEL_APPROVER: ['MODEL_METRICS_READ', 'MODEL_DIAGNOSTICS_READ', 'MODEL_APPROVE', 'MODEL_ACTIVATE', 'MODEL_ROLLBACK', 'MODEL_RELEASE_READ'],
  SUPPORT_OPERATOR: ['QNA_READ', 'QNA_ANSWER', 'QNA_STATE_CHANGE', 'QNA_HIDE'],
  AUDITOR: ['AUDIT_READ', 'SYSTEM_STATUS_READ'],
  ACCESS_ADMIN: ['ACCESS_READ', 'ACCESS_ASSIGN', 'ACCESS_REVOKE', 'AUDIT_READ'],
  SUPER_ADMIN: PERMISSIONS,
};

export const CONSOLE_ORDER = ['OPS', 'DATA', 'MODEL', 'SYSTEM'];

export function permissionsForRoles(roleIds) {
  return [...new Set((roleIds || []).flatMap((roleId) => ROLE_BUNDLES[roleId] || []))];
}

export function hasPermission(permissions, permission) {
  return Array.isArray(permissions) && permissions.includes(permission);
}
